import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { hashHistory } from 'react-router';

import '../css/image-gallery.css';
import '../css/main.css';

export default class PostPhotoGalleryComponent extends React.Component {

    componentWillMount() {
        this.props.findPhotos(this.props.response.get('card'),
            this.props.request.get('type'));
    }

    componentDidMount() {
    }

    expand() {
        this.props.expandContent();
    }

    previousPage() {
        this.props.expandContent();
        hashHistory.push("/auditingTarget");
        this.props.pop();
    }

    returnTakePhoto() {
        hashHistory.push("/takePostPhoto");
    }

    thumbnails(photos) {
        let ret = [];
        if (photos) {
            return photos;
        }
        return ret;
    }

    showNote() {
        if (this.props.request.get("mcase") && this.props.request.get("mcase").note) {
            return <span>{this.props.request.get("mcase").note}</span>;
        }
        return '';
    }

    deletePic(photoId) {
        this.props.deletePhotoById(photoId, this.props.response.get('card'),
            this.props.request.get('type'), "POST");
    }

    render() {

        let menuToggle = (show) => {
            if (show) {
                return 'menu-hide.svg';
            } else {
                return 'menu-show.svg';
            }
        }

        let headerImage = (category) => {
            if (category === 'CLOTH') {
                return "shirt.svg";
            } else if (category === 'PANT') {
                return "shorts.svg";
            }
            return 'kk25.jpg';
        }

        return (
            <div><span hidden> PostPhotoGalleryComponent  </span>
                <Row>
                    <div className="snapshot" style={{ marginTop: 30, marginBottom: -15 }}>
                        <Button onClick={(e) => { this.returnTakePhoto(); }}>
                            <img title='回拍照頁' alt='回拍照頁' src='return.svg' height="45" width="45" />
                        </Button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                    <h5 style={{ color: '#5371B6' }}>
                        <a alt="hide or show menus" onClick={(event) => {
                            this.expand();
                        }}><img src={menuToggle(this.props.menu.get('show'))} height="10" width="15" title="hide or show menus" alt="hide or show menus icon" />
                        </a>
                        <img alt='shorts' src={headerImage(this.props.request.get('type'))} height="30" width="30" />
                        <span className='highlight-B'>{this.props.response.get('card').code}</span> &gt;&gt;
                        檢點作業  &gt;&gt; 檢點拍照 &gt;&gt;&nbsp;
                        {this.props.request.get("mcase").orderId}&nbsp;-&nbsp;{this.showNote()}&nbsp;
                    <a onClick={(e) => { this.previousPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
                    </h5>
                </Row>
                <h4>檢點拍照-相片列表</h4>
                <Row>
                    {
                        this.thumbnails(this.props.response.get('photos')).map(
                            (item, index) =>
                                <Col xs={12} sm={6} key={item.id}>
                                    <a href={item.image} target="_blank">
                                        <img src={item.image} className="img-thumbnail" alt="" />
                                    </a>
                                    <div style={{ textAlign: 'center' }}>
                                        <span className="glyphicon glyphicon-trash"
                                            style={{ marginTop: 5, marginBottom: 25, fontSize: '2em', color: '#a94442', cursor: 'pointer' }}
                                            onClick={(event) => {
                                                this.deletePic(item.id);
                                            }} />
                                    </div>
                                </Col>
                        )
                    }
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PostPhotoGalleryComponent.jsx